



































import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganization,
  OversightOrganizationType,
} from '../../utils/OversightUtils';

interface ParentOption {
  type: OversightOrganizationType;
  options: {
    text?: string;
    value: OversightOrganization;
  }[];
  selected?: OversightOrganization | OversightOrganization[];
}

export default mixins().extend({
  props: {
    value: {
      type: Object as () => OversightOrganization,
    },
  },
  computed: {
    type: {
      get(): any {
        if (this.value.oversighttype) {
          return this.types?.find(
            (type) => type?.id === this.value?.oversighttype?.id
          );
        }
      },
      set(value: any) {
        this.value.oversighttype = value;
        this.$emit('input', this.value);
      },
    },
    typeOptions(): any {
      return this.types?.map((type) => ({
        text: this.$translate(type.name),
        value: type,
      }));
    },
  },
  data: function(): {
    parentOptions?: ParentOption[];
    types?: OversightOrganizationType[];
    oversights?: OversightOrganization[];
  } {
    return {
      parentOptions: undefined,
      types: undefined,
      oversights: undefined,
    };
  },
  async mounted() {
    try {
      const resp = await Promise.all([
        OversightUtils.api.type.list(),
        OversightUtils.api.instance.list(),
      ]);

      this.types = resp[0];
      this.oversights = resp[1];
      this.parentOptions = this.generateParentOptions();
    } catch (error) {
      this.$handleAPIError(error);
    }
  },
  methods: {
    generateParentOptions(): ParentOption[] {
      const options = (type: OversightOrganizationType) => {
        return (
          this.oversights?.filter(
            (oversight) => oversight.oversighttype.id === type.id
          ) || []
        ).map((oversight) => ({
          text: this.$translate(oversight.name),
          value: oversight,
        }));
      };

      const selected = (type: OversightOrganizationType) => {
        return options(type)
          .map((option) => option.value)
          ?.filter((oversight) =>
            this.value.parent?.map((parent) => parent.id).includes(oversight.id)
          );
      };

      return this.types
        ?.filter(
          (type) =>
            type.scope.children_type === 'oversight' &&
            type.scope.children_oversight_org_type === this.type?.id
        )
        .map((type) => ({
          type: type,
          options: options(type),
          selected: type.scope.mutually_exclusive_children
            ? selected(type)[0]
            : selected(type),
        })) as ParentOption[];
    },
    handleParentChange() {
      let merged: OversightOrganization[] = [];
      this.parentOptions
        ?.map((option) => option.selected)
        ?.forEach((selected) => {
          if (Array.isArray(selected)) {
            merged = merged.concat(selected);
          } else if (selected) {
            merged.push(selected);
          }
        });
      this.value.parent = merged;
      this.$emit('input', this.value);
    },
    handleTypeChange() {
      this.parentOptions = this.generateParentOptions();
      this.value.parent = [];
      this.$emit('input', this.value);
    },
  },
});
